import extend from 'extend';
import Q from 'q';
import _ from 'underscore';

import payment_getPayChannel
    from '../../../../../lib/data-service/payment/payment_getPayChannel';
import payment_paymentHandleTwo from '../../../../../lib/data-service/payment/payment_paymentHandleTwo';
import payment_notifyResult from '../../../../../lib/data-service/payment/payment_notifyResult';

import BasePaymentMethodSelector from '../component/base-payment-method-selector/index.vue';

export default {
    mixins: [
        BasePaymentMethodSelector,
    ],
    data() {
        return {
            init_parameter: {

                //在这里调用获取支付方式的接口
                get_payment_channel_entity_list(args) {
                    const __this__ = args.__this;
                    const companyId = __this__.data_get_params.companyId;
                    const isUseCredit = __this__.data_get_params.isUseCredit;
                    const orderAmount = __this__.data_get_params.orderAmount;

                    return Q.when()
                        .then(function () {
                            return payment_getPayChannel({
                                companyId: companyId,
                                isUseCredit: isUseCredit,
                                payAmount: orderAmount,
                                type: 1,
                            });
                        })
                        .then(function (data) {
                            const paymentChannels = data.paymentChannels;
                            const payment_channel_entity_list = paymentChannels;
                            return Q.resolve({
                                payment_channel_entity_list,
                                data_get_payment_channel_entity_list: data,
                            });
                        })
                        ;
                },

                //在这里调用支付的接口
                pay(args) {
                    const __this__ = args.__this;
                    const selected_payment_channel_entity_list = args.selected_payment_channel_entity_list;
                    const password = args.password;

                    const paymentChannelVos = _.chain(selected_payment_channel_entity_list)
                        .map(function (m) {
                            const payment_amount_number = m.payment_amount_number;
                            const code = m.code;
                            const o = {};
                            o.amount = payment_amount_number;
                            o.paymentChannel = code;
                            return o;
                        })
                        .value()
                    ;

                    return Q.when()
                        .then(function () {
                            const companyId = __this__.data_get_params.companyId;
                            const clubId = __this__.data_get_params.clubId;
                            const orderNo = __this__.data_get_params.orderNo;
                            const businessContent = __this__.data_get_params.businessContent;
                            const subject = __this__.data_get_params.subject;
                            const clientType = __this__.data_get_params.clientType;

                            return payment_paymentHandleTwo({
                                companyId,
                                clubId,
                                orderNo,
                                businessContent,
                                subject,
                                paymentChannelVos,
                                password,
                                clientType,
                            });
                        })
                        .then(function (data) {
                            const outTradeNo = data.outTradeNo;
                            const resultMap = data.resultMap;
                            const htmlStr = data.htmlStr;
                            return Q.resolve({
                                original_data: data,
                                outTradeNo,
                                resultMap,
                                htmlStr,
                            });
                        })
                        ;
                },

                //在这里调用检查支付状态的接口（不用实现轮询逻辑，轮询逻辑由内部实现）
                check_payment_status(args) {
                    const __this__ = args.__this;
                    const outTradeNo = args.outTradeNo;
                    return Q.when()
                        .then(function () {
                            return payment_notifyResult({
                                tradeNo: outTradeNo,
                            });
                        })
                        .then(function (data) {
                            const paymentStatus = data.paymentStatus;
                            return Q.resolve({
                                paymentStatus,
                                original_data: data,
                            });
                        })
                        ;
                },

                //在这里设置支付状态的定义（枚举值）
                get_payment_status_define() {
                    // 支付状态：0：已失效 1：支付中 2：已支付 3：支付失败
                    const payment_status_success = 2;
                    const payment_status_failure = 3;
                    return {
                        payment_status_success,
                        payment_status_failure,
                    };
                },

            },
        }
    },
}
